// TODO: вынести в env
export const TEST_HOSTS = ['localhost', 'test.atez.ru'];
export const PROD_HOST = 'atez.ru';

const hostname =
    typeof window !== 'undefined'
        ? window.location.hostname.replace(/^www\./, '').toLowerCase()
        : '';

export const isTestHost = TEST_HOSTS.includes(hostname);
